import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { PreviewControlGroup } from './preview-control-group';
import {
    PreviewPaneButtons,
    type PreviewPaneButton,
} from './preview-pane-buttons';

@Component({
    selector: 'qpx-preview-pane-control-groups',
    imports: [PreviewControlGroup, PreviewPaneButtons],
    template: `
        @for (group of groups(); track group) {
            <qpx-preview-control-group [attr.data-control-group]="group">
                <qpx-preview-pane-buttons
                    [choices]="choices()"
                    [controlGroup]="group"
                />
            </qpx-preview-control-group>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'contents' },
})
export class PreviewPaneControlGroups {
    public readonly choices = input<readonly PreviewPaneButton[]>([]);
    protected readonly groups = computed(() => [
        ...new Set(
            this.choices().flatMap((choice) =>
                choice.controlGroup ? [choice.controlGroup] : []
            )
        ),
    ]);
}
